import List from "@/components/list";
import vue from "@/main";

const Table = args => {

  const { listeners, props } = args;
  const onTrainInfo = listeners["onTrainInfo"] || function () { };
  
  const Deal = ({ props: { vo } }) => {
    const dealConf = [
      [
        "iconfont icchakanpeixunxiangqing_sel iconfont-adapt",
        "查看培训详情",
        () => onTrainInfo(vo.row),
        ""
      ]
    ];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: "姓名",
      prop: "userName",
      minWidth: "90",
    },{
      label: "工作单位",
      prop: "deptName",
      minWidth: "120",
      //showOverflowTooltip: true
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "120",
      // showOverflowTooltip: true
    },
    {
      label: "合计学时",
      prop: "hours",
      minWidth: "80",
    },{
      label: "操作",
      fixed: "right",
      width: "80",
      align: "left",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};
export default Table;
